import React from 'react';
import '../../styles/components/BotonInversiones.css';

/**
 * Botón del módulo Inversiones exterior. Lo usan las páginas, tablas y formularios
 * de todas las fuentes de carga (Racional, Fintual, PDF, …), para que se vean y se
 * comporten igual. Los demás atributos (onClick, disabled, title, …) pasan al botón.
 *
 * @param {Object} props
 * @param {'primario'|'secundario'|'peligro'|'discreto'} [props.variante='secundario'] -
 *   primario: la acción principal (cargar, validar, guardar); peligro: lo que saca algo
 *   de la DJ (descartar); discreto: cerrar
 * @param {boolean} [props.chico=false] - Para las acciones dentro de una tabla
 * @param {React.ReactNode} [props.icono] - Ícono a la izquierda del texto
 * @param {string} [props.type='button']
 */
const Boton = ({ variante = 'secundario', chico = false, icono, type = 'button', children, ...resto }) => (
    <button type={type} className={`invext-boton ${variante}${chico ? ' chico' : ''}`} {...resto}>
        {icono && <span className="invext-boton-icono" aria-hidden="true">{icono}</span>}
        {children}
    </button>
);

export default Boton;
